const CharterSpecialFeaturesRow = {
  getSettings: componentSettings => ({
    ...componentSettings,
    modifier: 'charter-speacial-features'
  })
};

export default CharterSpecialFeaturesRow;
